/*
*
* Micropagamenti Api
*
* @version 1.0.0
* @author Giorgia Cuozzo
* @since 22-Jan-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/micropagamenti/micropagamenti')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getInfos () {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/public/micropayments/infos',
      params: { isMPS: true, isNEXI: true, isISP: true }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getShops () {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/public/micropayments/shops',
      params: { status: 'ELIGIBLE' }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function activation (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/marketing-service/public/micropayments/activation',
      data: { ...params }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getHistory () {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/public/micropayments/request/list'
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
